// Assessor Names Service - Manage saved assessor names
export const AssessorNamesService = {
    STORAGE_KEY: 'rjb_assessor_names',
    LAST_USED_KEY: 'rjb_last_assessor_name',
    
    getAll(): string[] {
        try {
            const stored = localStorage.getItem(this.STORAGE_KEY);
            return stored ? JSON.parse(stored) : [];
        } catch {
            return [];
        }
    },

    getLastUsed(): string {
        try {
            return localStorage.getItem(this.LAST_USED_KEY) || '';
        } catch {
            return '';
        }
    },

    setLastUsed(name: string): void {
        try {
            if (name && name.trim()) {
                localStorage.setItem(this.LAST_USED_KEY, name.trim());
            }
        } catch {
            // Ignore errors
        }
    },
    
    add(name: string): void {
        if (!name || !name.trim()) return;
        const names = this.getAll();
        const trimmedName = name.trim();
        if (!names.includes(trimmedName)) {
            names.push(trimmedName);
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(names));
        }
        // Also save as last used
        this.setLastUsed(trimmedName);
    },

    remove(name: string): void {
        const names = this.getAll();
        const filtered = names.filter(n => n !== name);
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(filtered));
    },

    clear(): void {
        localStorage.removeItem(this.STORAGE_KEY);
        localStorage.removeItem(this.LAST_USED_KEY);
    }
};
